import { render, staticRenderFns } from "./LiftEdit.vue?vue&type=template&id=6737fe64&scoped=true&"
import script from "./LiftEdit.vue?vue&type=script&lang=js&"
export * from "./LiftEdit.vue?vue&type=script&lang=js&"
import style0 from "./LiftEdit.vue?vue&type=style&index=0&id=6737fe64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6737fe64",
  null
  
)

export default component.exports